'use client'

import { useEffect } from 'react'

import AOS from 'aos'
import 'aos/dist/aos.css'

import '../../css/style.css'

import Header from '@/components/ui/header'
import Footer from '@/components/ui/footer'

import Hero from '@/components/hero'
import Clients from '@/components/clients'
import Features from '@/components/features'
import TestimonialsCarousel from '@/components/testimonials-carousel'
import Testimonials from '@/components/testimonials'

import Illustration from '@/public/images/glow-top.svg'
import Image from 'next/image'
import { useLocale } from 'next-intl'

export default function Home() {

  
  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 1000,
      easing: 'ease-out-cubic',
    })
  })

  const local = useLocale()
  return (
    <>
      <Header />
      
      <div className={`font-inter antialiased bg-slate-900 text-slate-100 tracking-tight sticky`}>
        <div className="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">
        <main className="grow">
  <section className="relative">
    <div
      aria-hidden="true"
      className="absolute inset-0 overflow-hidden pointer-events-none -z-10"
    >
      <div className="absolute flex items-center justify-center top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 w-1/3 aspect-square">
        <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-50" />
      </div>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      {local == "fr" ? FR_PRIVACY() : EN_PRIVACY()}
    </div>
  </section>
</main>

<style
    dangerouslySetInnerHTML={{
      __html: 'h2 {    font-weight: bold !important;}'
    }}
   />
          </div>
      </div>
      <Footer />
    </>
  )
}


const FR_PRIVACY = () => {
  return (
    <div
        className="py-12 md:py-20"
        id="tarif"
      >
        <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
          <div>
            <div
              className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-200 pb-3"
              style={{
                marginTop: '40px'
              }}
            >
              Vexub
            </div>
          </div>
          <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">
            Politique de confidentialité
          </h1>
        </div>
        <div>
          <h2>
            1. À propos de cette Politique
          </h2>
          <p>
            Cette Politique de confidentialité explique comment nous (« Vexub ») collectons, partageons et utilisons vos informations personnelles lorsque vous utilisez notre site web vexub.fr ou lorsque vous souscrivez à nos services en tant que client ou fournisseur.
          </p>
          <br />
          <br />
          <h2>
            2. Informations personnelles que nous collectons et pourquoi
          </h2>
          <p>
            Les types d'informations personnelles que nous collectons à votre sujet et les raisons pour lesquelles nous les traitons sont les suivants :
          </p>
          <ul>
            <li>
              Adresse e-mail, données d'identification électronique (y compris lorsque vous vous inscrivez via Google ou Outlook) :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Fournir nos services à nos clients (y compris les utilisateurs en essai gratuit), gérer l'accès à nos services et activer la fonction de partage.
                </li>
                <li>
                  Fondement juridique du traitement : Nécessité contractuelle.
                </li>
              </ul>
            </li>
            <li>
              Données d'identification, données d'identification électronique et données d'utilisation de la connexion Internet :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Établir des statistiques commerciales et de fréquentation liées à l'utilisation de nos services.
                </li>
                <li>
                  Fondement juridique du traitement : Notre intérêt légitime à connaître la popularité de nos services pour optimiser leur visibilité ou leur interface.
                </li>
              </ul>
            </li>
            <li>
              Données d'identification, données d'identification électronique et données d'utilisation de la connexion Internet :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Fournir des réponses personnalisées à vos demandes d'informations via le chatbot ou lorsque vous nous contactez.
                </li>
                <li>
                  Fondement juridique du traitement : Notre intérêt légitime à répondre aux demandes.
                </li>
              </ul>
            </li>
            <li>
              Adresse e-mail, données d'identification :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Gérer notre relation avec les clients et les fournisseurs (y compris les factures et les paiements).
                </li>
                <li>
                  Fondement juridique du traitement : Nécessité contractuelle.
                </li>
              </ul>
            </li>
            <li>
              Nom et prénom, adresse e-mail :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Vous envoyer des mises à jour marketing et des messages concernant nos services.
                </li>
                <li>
                  Fondement juridique du traitement : Consentement (sauf si une exception légale s'applique, auquel cas nous nous appuierions sur notre intérêt légitime à promouvoir nos services).
                </li>
              </ul>
            </li>
            <li>
              Toute information pertinente ou potentiellement pertinente pour un litige ou une procédure judiciaire nous concernant :										
              <ul>
                <li>
                  Pourquoi nous les collectons : Litiges et procédures judiciaires.
                </li>
                <li>
                  Fondement juridique du traitement : Notre intérêt légitime à défendre nos droits et intérêts devant les tribunaux.
                </li>
              </ul>
            </li>
          </ul>
          <br />
          <br />
          <h2>
            3. Partage des données personnelles par Vexub
          </h2>
          <p>
            Nous pouvons partager vos informations personnelles avec les catégories de destinataires suivantes :
          </p>
          <ul>
            <li>
              Nos prestataires de services tiers qui traitent des données en notre nom, notamment dans les domaines des services de facturation et de paiement, de l'assistance clientèle, de l'hébergement du site web, du marketing et des newsletters, et de l'analyse de données.
            </li>
            <li>
              Toute autorité compétente en matière d'application de la loi, de réglementation, d'agence gouvernementale, de tribunal ou de tiers lorsque nous estimons que la divulgation est nécessaire : (i) conformément à la loi ou à la réglementation applicable, (ii) pour exercer, établir ou défendre nos droits légaux, ou (iii) pour protéger vos intérêts vitaux ou ceux d'une autre personne.
            </li>
            <li>
              Nos auditeurs, conseillers, représentants juridiques et agents similaires dans le cadre des services de conseil qu'ils nous fournissent à des fins commerciales légitimes, sous réserve de l'interdiction contractuelle d'utiliser les données personnelles à d'autres fins.
            </li>
            <li>
              Un acheteur potentiel (et ses agents et conseillers) dans le cadre de tout achat, fusion ou acquisition proposé de tout ou partie de notre entreprise, à condition que l'acheteur soit informé d'utiliser vos données personnelles uniquement aux fins divulguées dans cette Politique.
            </li>
            <li>
              Toute autre personne si vous avez donné votre consentement préalable à la divulgation.
            </li>
          </ul>
          <br />
          <br />
          <h2>
            4. Protection de votre vie privée
          </h2>
          <p>
            Nous traiterons les données personnelles conformément à cette Politique, comme suit :
          </p>
          <ul>
            <li>
              Équité : Nous traiterons les données personnelles équitablement. Cela signifie que nous sommes transparents sur la manière dont nous traitons les données personnelles et que nous les traiterons conformément à la loi applicable.
            </li>
            <li>
              Légalité : Nous traiterons les données personnelles uniquement sur des bases légales.
            </li>
            <li>
              Limitation de l'objectif : Nous traiterons les données personnelles à des fins spécifiques et légitimes et ne les traiterons pas d'une manière incompatible avec ces fins, sauf autorisation par les lois applicables en matière de protection des données.
            </li>
            <li>
              Minimisation des données : Nous traiterons les données personnelles qui sont adéquates, pertinentes et limitées à ce qui est nécessaire pour atteindre les objectifs pour lesquels les données sont traitées.
            </li>
            <li>
              Exactitude des données : Nous prendrons des mesures appropriées pour garantir que les données personnelles que nous détenons à votre sujet sont exactes, complètes et, si nécessaire, mises à jour. Cependant, il est également de votre responsabilité de veiller à ce que vos données personnelles soient aussi précises, complètes et actuelles que possible en nous informant rapidement de tout changement ou erreur. Vous devez nous informer de tout changement dans les données personnelles que nous détenons à votre sujet (par exemple, un changement d'adresse e-mail).
            </li>
            <li>
              Sécurité des données : Nous utilisons des mesures techniques et organisationnelles appropriées pour protéger les données personnelles que nous collectons et traitons à votre sujet. Les mesures que nous utilisons sont conçues pour fournir un niveau de sécurité adapté au risque lié au traitement de vos données personnelles.
            </li>
            <li>
              Conservation limitée : Nous conservons vos données personnelles de manière à pouvoir vous identifier aussi longtemps que nécessaire pour atteindre les objectifs pour lesquels nous traitons vos données et ne stockons pas vos données plus longtemps, sauf si nous devons nous conformer aux lois applicables.
            </li>
          </ul>
          <br />
          <br />
          <h2>
            5. Stockage, conservation et suppression des données
          </h2>
          <p>
            Nous conservons les données personnelles que nous collectons auprès de vous lorsque nous avons un besoin commercial légitime continu de le faire (par exemple, pour vous fournir un service que vous avez demandé ou pour nous conformer aux obligations légales, fiscales ou comptables applicables). Nous conservons les données des clients pendant une période maximale de 2 ans suivant la fin de notre relation contractuelle. Cependant, nous conserverons les données personnelles relatives à la comptabilité pendant une période maximale de 10 ans.
          </p>
          <p>
            Lorsque nous n'avons plus besoin de traiter vos données personnelles pour des besoins commerciaux légitimes, nous les supprimerons ou les anonymiserons. Si cela n'est pas possible (par exemple, parce que vos données personnelles ont été stockées dans des archives de sauvegarde), nous stockerons vos données personnelles de manière sécurisée et les isolerons de tout traitement ultérieur jusqu'à ce que la suppression soit possible.
          </p>
          <br />
          <br />
          <h2>
            6. Transferts internationaux de données
          </h2>
          <p>
            Vos données personnelles peuvent être transférées vers, et traitées dans, des pays autres que celui dans lequel vous résidez. Ces pays peuvent avoir des lois sur la protection des données différentes de celles de votre pays (et, dans certains cas, peuvent ne pas offrir la même protection).
          </p>
          <p>
            Plus précisément, nos serveurs sont situés en France, et nos prestataires de services tiers opèrent dans l'UE et aux États-Unis. Cela signifie que lorsque nous collectons vos données personnelles, nous pouvons les traiter dans l'un de ces pays.
          </p>
          <p>
            Cependant, nous avons pris les mesures appropriées pour exiger que vos données personnelles restent protégées conformément à cette Politique. Cela inclut la mise en œuvre des clauses contractuelles types de la Commission européenne pour les transferts de données personnelles avec nos prestataires de services tiers et partenaires. Des détails supplémentaires peuvent être fournis sur demande.
          </p>
          <br />
          <br />
          <h2>
            7. Vos droits en matière de protection des données
          </h2>
          <p>
            Vous avez les droits suivants en matière de protection des données :
          </p>
          <ul>
            <li>
              Si vous souhaitez accéder, corriger, mettre à jour ou demander la suppression de vos données personnelles, vous pouvez le faire à tout moment en nous contactant à l'adresse suivante : info@vexub.fr.
            </li>
            <li>
              De plus, dans certaines circonstances, tel que stipulé dans la législation applicable en matière de protection des données, vous pouvez vous opposer au traitement de vos données personnelles, nous demander de limiter le traitement de vos données personnelles ou demander la portabilité de vos données personnelles. Vous pouvez exercer ces droits en nous contactant à l'adresse e-mail mentionnée ci-dessus.
            </li>
            <li>
              Si nous avons collecté et traité vos données personnelles avec votre consentement, vous pouvez retirer votre consentement à tout moment. Le retrait de votre consentement n'affectera pas la licéité du traitement que nous avons effectué avant votre retrait, ni le traitement de vos données personnelles effectué en se fondant sur des motifs de traitement légaux autres que le consentement.
            </li>
            <li>
              Vous avez le droit de vous désabonner des communications marketing que nous vous envoyons à tout moment. Vous pouvez exercer ce droit en cliquant sur le lien "se désabonner" ou "opt-out" dans les e-mails marketing que nous vous envoyons.
            </li>
            <li>
              Si vous avez une réclamation ou une préoccupation concernant la manière dont nous traitons vos données personnelles, nous nous efforcerons de résoudre ces préoccupations. Si vous estimez que nous n'avons pas suffisamment pris en compte votre réclamation ou préoccupation, vous avez le droit de déposer une plainte auprès d'une autorité de protection des données concernant notre collecte et notre utilisation de vos données personnelles. Pour plus d'informations, veuillez contacter votre autorité locale de protection des données.
            </li>
          </ul>
          <br />
          <br />
          <h2>
            8. Liens vers d'autres sites web
          </h2>
          <p>
            Le Site peut contenir des liens hypertextes vers des sites web détenus et exploités par des tiers. Ces sites web ont leurs propres politiques de confidentialité, et nous vous encourageons à les examiner. Ils régiront l'utilisation des données personnelles que vous soumettez lors de votre visite sur ces sites web.
          </p>
          <p>
            Nous n'acceptons aucune responsabilité ni aucune obligation quant aux pratiques de confidentialité de ces sites web tiers, et votre utilisation de ces sites web se fait à vos propres risques.
          </p>
          <br />
          <br />
          <h2>
            9. YouTube API Services
          </h2>
          <p>
            Vexub utilise les YouTube API Services pour permettre à ses utilisateurs de publier leurs vidéos générées par IA directement sur leur chaîne YouTube et d'importer des vidéos YouTube comme matière première pour la création de clips.
          </p>
          <p>
            En utilisant les fonctionnalités YouTube de Vexub, vous acceptez les{' '}
            <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">Conditions d'utilisation de YouTube</a>
            {' '}et reconnaissez la{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">Politique de confidentialité de Google</a>.
          </p>
          <p>
            Lorsque vous connectez votre compte YouTube via OAuth, nous collectons et stockons : votre identifiant de chaîne, le nom de votre chaîne, votre photo de profil, votre nombre d'abonnés, ainsi que les jetons d'accès et de rafraîchissement nécessaires pour publier des vidéos en votre nom. Ces informations sont utilisées uniquement pour fournir les fonctionnalités de publication YouTube et ne sont partagées avec aucun tiers.
          </p>
          <p>
            Vous pouvez révoquer l'accès de Vexub à votre compte YouTube à tout moment via la page de sécurité de votre compte Google :{' '}
            <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">myaccount.google.com/permissions</a>
            . Vous pouvez également déconnecter votre compte directement depuis Vexub via la page Publish (/app/publish), ce qui supprimera tous les jetons stockés.
          </p>
          <p>
            Pour toute demande de suppression de vos données YouTube stockées par Vexub, contactez-nous à info@vexub.fr.
          </p>
          <br />
          <p>
            Dernière mise à jour : 07/05/2026
          </p>
        </div>
      </div>
  )
}

const EN_PRIVACY = () => {
  return (
    <div className="py-12 md:py-20" id="terms">
  <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
    <div>
      <div className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-200 pb-3" style={{ marginTop: '40px' }}>Vexub</div>
    </div>
    <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">Privacy Policy</h1>
  </div>
  <div>
    <h2>1. About this Policy</h2>
    <p>This Privacy Policy explains how we collect, share, and use your personal information when you use our website vexub.fr or when you subscribe to our services as a customer or provider.</p><br /><br />
    <h2>2. Personal Information We Collect and Why</h2>
    <p>The types of personal information we collect about you and the reasons we process them are as follows:</p>
    <ul>
      <li>Email address, electronic identification data (including when you sign up via Google or Outlook):										
        <ul>
          <li>Why we collect it: To provide our services to our customers (including free trial users), manage access to our services, and enable the sharing feature.</li>
          <li>Legal basis for processing: Contractual necessity.</li>
        </ul>
      </li>
      <li>Identification data, electronic identification data, and Internet connection usage data:										
        <ul>
          <li>Why we collect it: To establish business and traffic statistics related to the use of our services.</li>
          <li>Legal basis for processing: Our legitimate interest in knowing the popularity of our services to optimize their visibility or interface.</li>
        </ul>
      </li>
      <li>Identification data, electronic identification data, and Internet connection usage data:										
        <ul>
          <li>Why we collect it: To provide personalized responses to your information requests via chatbot or when you contact us.</li>
          <li>Legal basis for processing: Our legitimate interest in responding to requests.</li>
        </ul>
      </li>
      <li>Email address, identification data:										
        <ul>
          <li>Why we collect it: To manage our relationship with customers and suppliers (including invoices and payments).</li>
          <li>Legal basis for processing: Contractual necessity.</li>
        </ul>
      </li>
      <li>First and last name, email address:										
        <ul>
          <li>Why we collect it: To send you marketing updates and messages about our services.</li>
          <li>Legal basis for processing: Consent (unless a legal exception applies, in which case we rely on our legitimate interest in promoting our services).</li>
        </ul>
      </li>
      <li>Any information relevant or potentially relevant to a dispute or legal proceeding involving us:										
        <ul>
          <li>Why we collect it: Disputes and legal proceedings.</li>
          <li>Legal basis for processing: Our legitimate interest in defending our rights and interests in court.</li>
        </ul>
      </li>
    </ul><br /><br />
    <h2>3. Sharing of Personal Data by Vexub</h2>
    <p>We may share your personal information with the following categories of recipients:</p>
    <ul>
      <li>Our third-party service providers who process data on our behalf, including billing and payment services, customer support, website hosting, marketing and newsletters, and data analysis.</li>
      <li>Any competent law enforcement body, regulatory, government agency, court, or third party where we believe disclosure is necessary: (i) under applicable law or regulation, (ii) to exercise, establish, or defend our legal rights, or (iii) to protect your vital interests or those of another person.</li>
      <li>Our auditors, advisors, legal representatives, and similar agents in connection with the advisory services they provide to us for legitimate business purposes, subject to the contractual prohibition of using personal data for other purposes.</li>
      <li>A potential buyer (and its agents and advisors) in connection with any proposed purchase, merger, or acquisition of any part of our business, provided that the buyer is informed to use your personal data only for the purposes disclosed in this Policy.</li>
      <li>Any other person if you have given your prior consent to the disclosure.</li>
    </ul><br /><br />
    <h2>4. Protecting Your Privacy</h2>
    <p>We will process personal data in accordance with this Policy as follows:</p>
    <ul>
      <li>Fairness: We will process personal data fairly. This means we are transparent about how we process personal data and will process them in accordance with applicable law.</li>
      <li>Legality: We will process personal data only on legal grounds.</li>
      <li>Purpose limitation: We will process personal data for specific and legitimate purposes and will not process them in a manner incompatible with those purposes unless authorized by applicable data protection laws.</li>
      <li>Data minimization: We will process personal data that are adequate, relevant, and limited to what is necessary to achieve the purposes for which the data are processed.</li>
      <li>Data accuracy: We will take appropriate steps to ensure that personal data we hold about you are accurate, complete, and, if necessary, kept up to date. However, it is also your responsibility to ensure that your personal data are as accurate, complete, and current as possible by promptly informing us of any changes or errors. You should inform us of any changes to the personal data we hold about you (e.g., a change in your email address).</li>
      <li>Data security: We use appropriate technical and organizational measures to protect the personal data we collect and process about you. The measures we use are designed to provide a level of security appropriate to the risk of processing your personal data.</li>
      <li>Limited retention: We will retain your personal data in a manner that allows us to identify you as long as necessary to achieve the purposes for which we process your data and do not store your data longer, unless we must comply with applicable laws.</li>
    </ul><br /><br />
    <h2>5. Data Storage, Retention, and Deletion</h2>
    <p>We retain the personal data we collect from you where we have an ongoing legitimate business need to do so (e.g., to provide you with a service you have requested or to comply with applicable legal, tax, or accounting obligations). We retain customer data for a maximum period of 2 years following the end of our contractual relationship. However, we will retain personal data related to accounting for a maximum period of 10 years.</p>
    <p>When we no longer need to process your personal data for legitimate business needs, we will either delete or anonymize them. If this is not possible (e.g., because your personal data have been stored in backup archives), we will securely store your personal data and isolate them from any further processing until deletion is possible.</p><br /><br />
    <h2>6. International Data Transfers</h2>
    <p>Your personal data may be transferred to, and processed in, countries other than the country in which you reside. These countries may have different data protection laws than your country (and, in some cases, may not offer the same protection).</p>
    <p>Specifically, our servers are located in France, and our third-party service providers operate in the EU and the United States. This means that when we collect your personal data, we may process them in any of these countries.</p>
    <p>However, we have taken appropriate measures to require that your personal data remain protected in accordance with this Policy. This includes implementing the European Commission's standard contractual clauses for transfers of personal data with our third-party service providers and partners. Further details can be provided upon request.</p><br /><br />
    <h2>7. Your Data Protection Rights</h2>
    <p>You have the following data protection rights:</p>
    <ul>
      <li>If you wish to access, correct, update, or request deletion of your personal data, you can do so at any time by contacting us at info@vexub.fr.</li>
      <li>Additionally, in certain circumstances, as stipulated by applicable data protection legislation, you can object to processing your personal data, ask us to restrict processing your personal data, or request the portability of your personal data. You can exercise these rights by contacting us at the email address mentioned above.</li>
      <li>If we have collected and processed your personal data with your consent, you can withdraw your consent at any time. Withdrawing your consent will not affect the lawfulness of any processing we conducted before your withdrawal, nor will it affect the processing of your personal data conducted in reliance on lawful processing grounds other than consent.</li>
      <li>You have the right to opt-out of marketing communications we send you at any time. You can exercise this right by clicking on the "unsubscribe" or "opt-out" link in the marketing emails we send you.</li>
      <li>If you have a complaint or concern about how we process your personal data, we will strive to address those concerns. If you believe we have not sufficiently addressed your complaint or concern, you have the right to file a complaint with a data protection authority regarding our collection and use of your personal data. For more information, please contact your local data protection authority.</li>
    </ul><br /><br />
    <h2>8. Links to Other Websites</h2>
    <p>The Site may contain hyperlinks to websites owned and operated by third parties. These websites have their own privacy policies, and we encourage you to review them. They will govern the use of personal data you submit while visiting these websites.</p>
    <p>We accept no responsibility or liability for the privacy practices of these third-party websites, and your use of these websites is at your own risk.</p><br /><br />
    <h2>9. YouTube API Services</h2>
    <p>Vexub uses YouTube API Services to allow its users to publish their AI-generated videos directly to their YouTube channel and to import YouTube videos as source material for clip creation.</p>
    <p>By using Vexub's YouTube features, you agree to the{' '}
      <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">YouTube Terms of Service</a>
      {' '}and acknowledge the{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">Google Privacy Policy</a>.
    </p>
    <p>When you connect your YouTube account via OAuth, we collect and store: your channel ID, channel name, profile picture, subscriber count, and the access and refresh tokens required to publish videos on your behalf. This information is used only to provide YouTube publishing features and is not shared with any third party.</p>
    <p>You can revoke Vexub's access to your YouTube account at any time via the security page of your Google account:{' '}
      <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer" className="text-purple-400 underline">myaccount.google.com/permissions</a>
      . You can also disconnect your account directly from Vexub via the Publish page (/app/publish), which will delete all stored tokens.</p>
    <p>For any request regarding deletion of your YouTube data stored by Vexub, please contact us at info@vexub.fr.</p><br />
    <p>Last updated: 07/05/2026</p>
  </div>
</div>

  )
}